var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import StringWidget from 'components/StringWidget/StringWidget';
import { amountFormatterString as amountToString } from 'utils/paymentHelper';
import coinIcon from 'images/super-coin.svg';
import cx from 'classnames';
import styles from './BreakupTable.css';
export function Label(props) {
    const { className } = props, rest = __rest(props, ["className"]);
    const finalClass = cx(className, styles['column-label']);
    return (<td className={finalClass}>
			<StringWidget {...rest}/>
		</td>);
}
export function Value(props) {
    const { negative = false, rawAmount, className, addRupee = true, convertibleAmount } = props;
    let amountStr = props.amountStr;
    // Since amountStr is optional, default to rawAmount if amountStr is empty
    // string.
    if (!amountStr) {
        amountStr = amountToString(rawAmount);
    }
    let finalValue = negative ? `− ${amountStr}` : amountStr;
    let coinPrice;
    const coinAmount = convertibleAmount && convertibleAmount.find(c => c.type === 'COIN');
    if (addRupee && !coinAmount) {
        finalValue = negative ? `− ₹${amountStr}` : `₹${amountStr}`;
    }
    if (coinAmount && coinAmount.count) {
        coinPrice = (<StringWidget strKey="coinPrice" className={styles['coin-price']} attributes={{
            amount: finalValue,
            coinSymbol: <img src={coinIcon} className={styles['coin-icon']}/>,
            noOfCoins: coinAmount.count
        }}/>);
    }
    const finalClassName = cx(className, styles['column-amount']);
    return <td className={finalClassName}>{coinPrice || finalValue}</td>;
}
